import {
  Category,
  CategoryType,
  GeneralCategory,
  SubCategory,
} from "../../domain";
import {
  CategoriesRemoteDataSourceError,
  Endpoints,
  RemoteDataSource,
} from "../core";

export class CategoriesRemoteDataSource extends RemoteDataSource {
  public async addGeneralCategory(title: string): Promise<void> {
    try {
      await this.post(Endpoints.addGeneralCategory, {
        body: {
          general_category: title,
          add: true,
          sub_categories: [],
        },
      });
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async addSubCategoryToGeneralCatgory(
    subCategoryId: string,
    generalCategoryId: string
  ) {
    try {
      await this.post(Endpoints.addGeneralCategory, {
        body: {
          general_category: generalCategoryId,
          add: false,
          sub_categories: [{ id: subCategoryId }],
        },
      });
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async addCategoryToSubCatgory(
    categoryId: string,
    subCategoryId: string
  ) {
    try {
      await this.post(Endpoints.addSubCategory, {
        body: {
          sub_category: subCategoryId,
          // add, this is a wrong key on the server
          data: false,
          categories: [{ id: categoryId }],
        },
      });
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async deleteGeneralCategory(id: string): Promise<void> {
    try {
      await this.post(Endpoints.removeGeneralCategory, { body: { id } });
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async listGeneralCategories(): Promise<GeneralCategory[]> {
    try {
      const res = await this.get(Endpoints.listGeneralCategories);
      return res.data.map((json: any) =>
        new GeneralCategory().deserialize(json)
      );
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async addSubCategory(title: string): Promise<SubCategory> {
    try {
      const res = await this.post(Endpoints.addSubCategory, {
        body: {
          sub_category: title,
          // add, this is a wrong key on the server
          data: true,
          categories: [],
        },
      });
      return new SubCategory().deserialize(res.data.sub_category);
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async deleteSubCategory(id: string): Promise<void> {
    try {
      await this.post(Endpoints.removeSubCategory, { body: { id } });
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async addCategory(title: string): Promise<Category> {
    try {
      const res = await this.post(Endpoints.addCategory, {
        body: { category: title },
      });
      return new Category().deserialize(res.data.category);
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async deleteCategory(id: string): Promise<void> {
    try {
      await this.post(Endpoints.removeCategory, { body: { id } });
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }

  public async editCategory(
    categoryType: CategoryType,
    id: string,
    title: string
  ): Promise<void> {
    try {
      await this.patch(Endpoints.editCategory, {
        body: {
          id,
          category_type: categoryType,
          title,
        },
      });
    } catch (error) {
      if (!error.response) throw CategoriesRemoteDataSourceError.networkError();
      throw CategoriesRemoteDataSourceError.serverError();
    }
  }
}
